import { CoachingInsightSessionKeys, OAFilter } from '../models/oa.model';

/**
 *   function for save ActivePerformer to sessionStorage
 * @function getActivePerformer
 * @param  {boolean} _showActivePerformer
 */
// eslint-disable-next-line @typescript-eslint/explicit-function-return-type
export function setActivePerformer(_showActivePerformer: boolean) {
    const obj = JSON.stringify(_showActivePerformer);
    sessionStorage.setItem(
        CoachingInsightSessionKeys.SHOW_ACTIVE_PERFORMER,
        obj,
    );
}
/**
 *   function for getting ActivePerformer from sessionStorage
 * @function getActivePerformer
 * @returns boolean
 */
export function getActivePerformer(): boolean {
    const obj = JSON.parse(
        sessionStorage.getItem(
            CoachingInsightSessionKeys.SHOW_ACTIVE_PERFORMER,
        ),
    );
    if (obj == null) {
        return null;
    }
    return obj;
}

/**
 * function for Save filter options to sessionStorage
 * @function saveFilterOptions
 * @param  {OAFilter} filterOptions
 * @returns void
 */
export function saveFilterOptions(filterOptions: OAFilter): void {
    sessionStorage.setItem(
        CoachingInsightSessionKeys.FILTER_OPTIONS,
        JSON.stringify(filterOptions),
    );
}

/**
 * function for getting filter options from sessionStorage
 * @function getFilterOptions
 * @returns OAFilter
 */
export function getFilterOptions(): OAFilter {
    let filterOptions: OAFilter;
    try {
        filterOptions = JSON.parse(
            sessionStorage.getItem(CoachingInsightSessionKeys.FILTER_OPTIONS),
        );
    } catch (e) {}
    filterOptions = filterOptions || null;
    return filterOptions;
}

/**
 * function for clear sessionStorage
 * @function clearSessionStorage
 * @returns void
 */
export function clearSessionStorage(): void {
    sessionStorage.removeItem(CoachingInsightSessionKeys.FILTER_OPTIONS);
    sessionStorage.removeItem(CoachingInsightSessionKeys.SHOW_ACTIVE_PERFORMER);
    sessionStorage.removeItem(CoachingInsightSessionKeys.COLUMN_CONFIG_ITEMS);
}
export function clearCoachingInsightUser(): void {
    sessionStorage.removeItem(
        CoachingInsightSessionKeys.COACHINGINSIGHT_USERID,
    );
}
